import {
    CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL,
    CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL,
    CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT,
} from 'Redux/actionTypes';

export const createDiagnosticDeviceSearchCommandsRequest = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST,
    payload: data,
})

export const createDiagnosticDeviceSearchCommandsResult = (result) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_RESULT,
    payload: result,
})

export const createDiagnosticDeviceSearchDeviceModelRequest = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST,
    payload: data
})

export const createDiagnosticDeviceSearchDeviceModelResult = (result) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_RESULT,
    payload: result
})

export const createDiagnosticDeviceOpenModal = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_OPEN_MODAL,
    payload: data
})

export const createDiagnosticDeviceCloseModal = () => ({
    type: CREATE_DIAGNOSTIC_DEVICE_CLOSE_MODAL,
})

export const createDiagnosticDeviceGetDeviceRequest = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST,
    payload: data,
})

export const createDiagnosticDeviceGetDeviceResult = (result) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_RESULT,
    payload: result,
})

export const createDiagnosticDeviceRequest = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_REQUEST,
    payload: data,
})

export const createDiagnosticDeviceResult = (result) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_RESULT,
    payload: result,
})

export const createDiagnosticDeviceSetDevices = (data) => ({
    type: CREATE_DIAGNOSTIC_DEVICE_SET_DEVICES,
    payload: data,
})